import React from "react";
import { Link } from "react-router-dom";
import { DoorOpen, Mail, MapPin, Phone } from "lucide-react";
import { MapSingle } from "@/components/Map";

export default function Footer() {
  return (
    <footer className="mv-green-bg text-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: "var(--mv-gold)" }}>
              <DoorOpen size={18} strokeWidth={1.75} className="mv-green-text" />
            </div>
            <div>
              <div className="font-display text-2xl">Mavula <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Investment</span></div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-white/70">Open Doors</div>
            </div>
          </div>
          <p className="font-accent italic text-xl md:text-2xl leading-snug max-w-lg" style={{ color: "var(--mv-gold)" }}>
            "Opening Doors, Building Homes, Creating Futures, Keeping Promises."
          </p>
          <p className="mt-6 text-white/75 text-[14px] max-w-lg leading-relaxed">
            Mavula Investment Ltd offers a structured property-purchase pathway — not a bank, not a
            remittance service, not an investment product. Funds are processed through licensed payment
            partners and used only to buy, build, or secure property in your home country.
          </p>
        </div>

        <div>
          <h4 className="text-[12px] tracking-[0.22em] uppercase text-white/60 mb-4">Trust</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/about" className="hover:text-white text-white/85" data-testid="footer-about">About Us</Link></li>
            <li><Link to="/waiting-list" className="hover:text-white text-white/85" data-testid="footer-waiting-list" style={{ color: "#F8D57E" }}>Join Waiting List</Link></li>
            <li><a href="https://fair-connect-2.emergent.host" target="_blank" rel="noopener noreferrer" className="hover:text-white text-white/85 inline-flex items-center gap-1" data-testid="footer-pula-community">Pula Community <span className="text-[10px] opacity-70">↗</span></a></li>
            <li><Link to="/legal-status" className="hover:text-white text-white/85" data-testid="footer-legal-status">Legal Status</Link></li>
            <li><Link to="/why-mavula" className="hover:text-white text-white/85" data-testid="footer-why-mavula">Why MAVULA</Link></li>
            <li><Link to="/safety" className="hover:text-white text-white/85" data-testid="footer-safety">Safety & Protections</Link></li>
            <li><Link to="/agent-portal" className="hover:text-white text-white/85" data-testid="footer-agent-portal">Agent Portal</Link></li>
            <li><Link to="/downloads" className="hover:text-white text-white/85" data-testid="footer-downloads">Documents & Downloads</Link></li>
            <li><Link to="/team" className="hover:text-white text-white/85" data-testid="footer-team">Our Team</Link></li>
            <li><Link to="/faq" className="hover:text-white text-white/85" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/stories" className="hover:text-white text-white/85" data-testid="footer-stories">Success Wall</Link></li>
            <li><Link to="/builders" className="hover:text-white text-white/85" data-testid="footer-builders">Verified Builders</Link></li>
            <li><Link to="/roadmap" className="hover:text-white text-white/85" data-testid="footer-roadmap">Public Roadmap</Link></li>
            <li><Link to="/impact" className="hover:text-white text-white/85" data-testid="footer-impact">Impact Reports</Link></li>
            <li><Link to="/pula" className="hover:text-white text-white/85" data-testid="footer-pula">Pula Ecosystem</Link></li>
            <li><a href="https://www.pulalove.com/learn" target="_blank" rel="noopener noreferrer" className="hover:text-white text-white/85 inline-flex items-center gap-1.5" data-testid="footer-pula-learn">Pula Learn <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-white/10 border border-white/20">pre-launch</span> <span className="text-[10px] opacity-70">↗</span></a></li>
            <li><Link to="/scam-warning" className="hover:text-white text-white/85" data-testid="footer-scam-warning" style={{ color: "#F8D57E" }}>⚠ Scam Warning</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[12px] tracking-[0.22em] uppercase text-white/60 mb-4">Policies</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/policies#equal-access" className="hover:text-white text-white/85">Equal Access</Link></li>
            <li><Link to="/policies#privacy" className="hover:text-white text-white/85">Privacy</Link></li>
            <li><Link to="/policies#terms" className="hover:text-white text-white/85">Terms</Link></li>
            <li><Link to="/policies#payments" className="hover:text-white text-white/85">Payments</Link></li>
            <li><Link to="/policies#compliance" className="hover:text-white text-white/85">Compliance</Link></li>
            <li><Link to="/security" className="hover:text-white text-white/85" data-testid="footer-security">Security</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[12px] tracking-[0.22em] uppercase text-white/60 mb-4">Institutional</h4>
          <ul className="space-y-2.5 text-[14px]">
            <li><Link to="/investors" className="hover:text-white text-white/85" data-testid="footer-investors">Institutional Enquiries</Link></li>
            <li><Link to="/how-your-money-is-held" className="hover:text-white text-white/85" data-testid="footer-money-held">Where your money sits</Link></li>
            <li><Link to="/risk-realities" className="hover:text-white text-white/85" data-testid="footer-risk">Risk &amp; Realities</Link></li>
            <li><Link to="/protections" className="hover:text-white text-white/85" data-testid="footer-protections">Cooling off &amp; buy-back</Link></li>
            <li><Link to="/office-hours" className="hover:text-white text-white/85" data-testid="footer-office-hours">Office hours</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[12px] tracking-[0.22em] uppercase text-white/60 mb-4">Reach Us</h4>
          <ul className="space-y-3 text-[14px] text-white/85">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5" style={{color: "var(--mv-gold)"}}/> +44 7424 311882</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5" style={{color: "var(--mv-gold)"}}/> Sebata@pulalove.com</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" style={{color: "var(--mv-gold)"}}/>
              <span>
                Spaces Lewis Building<br/>
                35 Bull Street<br/>
                Birmingham B4 6AF<br/>
                United Kingdom
              </span>
            </li>
          </ul>
          <div className="mt-4 mv-no-lowdata" data-testid="footer-map">
            <MapSingle lat={52.4830} lng={-1.8936} label="MAVULA · Birmingham Office · Spaces Lewis Building" height={160} zoom={14} />
          </div>
        </div>
      </div>

      {/* Impact badge — visible on every page */}
      <div className="border-t border-white/10" data-testid="footer-impact-badge">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-[13px] text-white/85 text-center">
          <span className="inline-flex items-center gap-2">
            <span aria-hidden="true">💧</span>
            <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Building homes + creating livelihoods.</span>
          </span>
          <span className="text-white/60">First projects: <strong className="text-white">targeting 900+ local jobs</strong></span>
          <span className="text-white/60"><strong className="text-white">40%</strong> local land reservation</span>
          <Link to="/impact" className="underline underline-offset-4 hover:text-[color:var(--mv-gold)] transition" data-testid="footer-impact-link">See impact →</Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 text-[12px] text-white/60 flex flex-wrap justify-between gap-3">
          <span>© {new Date().getFullYear()} MAVULA Investment Ltd — All rights reserved.</span>
          <span>Structured Property Purchase Pathway · Not a bank · Not an investment product</span>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-8 pb-6 text-[11.5px] text-white/55 leading-relaxed" data-testid="footer-company-details">
          <div>
            <strong className="text-white/75">Mavula Investment Ltd</strong> — Registered in England &amp; Wales · Company No. <span className="font-mono">17368822</span> · Registered office: Lewis Building, 35 Bull Street, Birmingham, B4 6AF, United Kingdom. Botswana registered operations in progress.
          </div>
          <div className="mt-1" data-testid="footer-group-disclosure">
            Part of the <strong className="text-white/75">MAVULA Group</strong>. Parent of <a href="https://fair-connect-2.emergent.host" target="_blank" rel="noopener noreferrer" className="underline hover:text-white" data-testid="footer-fair-connect-link">Fair Connect</a> (a MAVULA Group company).
          </div>
          <div className="mt-2 italic" data-testid="footer-risk-warning">
            Mavula Investment Ltd — Registered in England &amp; Wales. Not authorised or regulated by the FCA. Not a bank. Structured purchase pathways are not investment products; no returns or yields are guaranteed. Regulated payment services provided by licensed partners. See our <Link to="/legal-status" className="underline hover:text-white">Legal Status</Link> page.
          </div>
        </div>
      </div>
    </footer>
  );
}
